import CloseIcon from '@mui/icons-material/Close'; // Import CloseIcon
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../../store/reducers/userReducer';

const SignUpButton = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const snackbar = useSnackbar();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEmail('');
    setPassword('');
    setRetypePassword('');
    setFirstName('');
    setLastName('');
  };

  const handleSignUp = async () => {
    if(email==='' || password==='' || retypePassword==='' || firstName==='' || lastName==='') {
      snackbar.enqueueSnackbar('All fields must be filled out!', { variant: 'error', autoHideDuration: 2000 });

    }
    else if(password !== retypePassword) {
      snackbar.enqueueSnackbar('Passwords do not match!', { variant: 'error', autoHideDuration: 2000 });
    }
    else{
      try{
        const response = await axios.post('/signup', {
          first_name: firstName,
          last_name: lastName,
          email: email,
          password: password,
        })
        if(response.status===200){
          snackbar.enqueueSnackbar('Signed up successfully!', { variant: 'success', autoHideDuration: 2000 });
          dispatch(setUser({ email: email, token: response.data.token, likedProducts: [] }));
          handleClose();  

        }
        else if(response.status===401){
          snackbar.enqueueSnackbar(response.data.message, { variant: 'error', autoHideDuration: 2000 });
        }
        else{
          snackbar.enqueueSnackbar("Something went wrong", { variant: 'error', autoHideDuration: 2000 });
        }
      }
      catch(error){
        snackbar.enqueueSnackbar(error.response.data.message, { variant: 'error', autoHideDuration: 2000 });
      }

    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential); // Decode token to get user info
      const response = await axios.post("/auth/google", {
        token: credentialResponse.credential,
      });

      if (response.status === 200) {
        snackbar.enqueueSnackbar("Signed up with Google successfully!", {
          variant: "success",
          autoHideDuration: 2000,
        });

        dispatch(
          setUser({
            email: decoded.email,
            token: response.data.token,
            likedProducts: [],
          })
        );

        handleClose();
      } else {
        snackbar.enqueueSnackbar(response.data.message || "Google sign-up failed!", {
          variant: "error",
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      snackbar.enqueueSnackbar(error.response?.data?.message || "Google sign-up failed!", {
        variant: "error",
        autoHideDuration: 2000,
      });
    }
  };

  if(user.email!=''){
    return (
      <Box sx={{ paddingTop: '3px' }}>
        {/* <Button
          variant="contained"
          onClick={console.log('open profile')}
          sx={{
            borderRadius: '20px', 
            backgroundColor: '#EF4F26',
            width: '100px',
            height: '40px',
            color: 'white',
            '&:hover': {
              backgroundColor: '#ff6c47',
            },
          }}
        >
          Profile
        </Button> */}
      </Box>
    );  
  }

  return (
    <Box sx={{ paddingTop: '3px' }}>
      <Button
        variant="contained"
        onClick={handleClickOpen}
        sx={{
          borderRadius: '20px', 
          backgroundColor: '#EF4F26',
          width: '100px',
          height: '40px',
          color: 'white',
          '&:hover': {
            backgroundColor: '#ff6c47',
          },
        }}
      >
        Sign Up
      </Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          Sign Up
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="First Name"
            type="firstName"
            fullWidth
            variant="outlined"
            value={firstName} 
            onChange={(e) => setFirstName(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            label="Last Name"
            type="LastName"
            fullWidth
            variant="outlined"
            value={lastName} 
            onChange={(e) => setLastName(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Password"
            type="password"
            fullWidth
            variant="outlined"
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
          />
          <TextField
            margin="dense"
            label="Re-Type Password"
            type="password"
            fullWidth
            variant="outlined"
            value={retypePassword} 
            onChange={(e) => setRetypePassword(e.target.value)}
          />

           {/* Google Sign-In Button */}
           <Box sx={{ mt: 3, textAlign: "center" }}>
            <GoogleOAuthProvider clientId="16170073933-hpq58n4hljb49pla98rp2p95sbt1dj1g.apps.googleusercontent.com">
            <Box 
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={() => snackbar.enqueueSnackbar("Google Sign-Up Failed", { variant: "error" })}
                  theme="outline"
                  width="300px"
                  text="continue_with"
                  shape="pill"
                />
              </Box>
            </GoogleOAuthProvider>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'center', 
            paddingBottom: '16px', 
          }}
        >
          <Button
            onClick={handleSignUp}
            sx={{
              backgroundColor: 'orange',
              color: 'white',
              width: '150px', 
              height: '50px',
              '&:hover': {
                backgroundColor: 'darkorange',
              },
            }}
          >
            Sign Up
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SignUpButton;
